<template>
  <img :src="src" alt="menu" @click="$emit('click')" />
</template>

<script>
import lightSrc from '@/assets/common/menu-w.svg';
import darkSrc from '@/assets/common/menu.svg';

export default {
  name: 'ShowMenu',
  props: {
    light: Boolean,
  },
  inject: ['isBodyAi'],
  computed: {
    src() {
      // eslint-disable-next-line no-nested-ternary
      return this.isBodyAi ? lightSrc : this.light ? lightSrc : darkSrc;
    },
  },
};
</script>
